import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const languages = [
  { code: 'id', label: 'Indonesia', short: 'ID' },
  { code: 'en', label: 'English', short: 'EN' },
];

export default function LanguagePicker({ lang, setLang, label = 'Choose language' }) {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);
  const activeLang = languages.find((item) => item.code === lang) || languages[0];

  useEffect(() => {
    const close = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  function selectLanguage(code) {
    if (code !== lang) setLang(code);
    setOpen(false);
  }

  return (
    <div className={open ? 'language-wrap is-open' : 'language-wrap'} ref={pickerRef}>
      <button
        className="language"
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="listbox"
        aria-expanded={open}
        title={label}
      >
        {activeLang.short} <ChevronDown size={15} />
      </button>

      <div className="language-menu" role="listbox" aria-label={label}>
        {languages.map((item) => (
          <button
            key={item.code}
            className={item.code === lang ? 'is-active' : ''}
            type="button"
            onClick={() => selectLanguage(item.code)}
            role="option"
            aria-selected={item.code === lang}
          >
            <span>{item.short}</span>
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
